import {
    mapActions,
    mapGetters
} from 'vuex';
import FiltreLateralI18n from './FiltreLateral.i18n.js';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {

    components: {VueSlider,},

    props: {
    },

    computed: {
        ...mapGetters([]),
    },

    data() {
        return {
            isFiltreDisplayed: false,
            styleHeight: '',
        };
    },

    watch: {},

    methods: {
      toggleDisplayFiltre() {
        this.isFiltreDisplayed = !this.isFiltreDisplayed
      },
      setComponentHeight() {
        const top = this.$refs.zoneFiltre.getBoundingClientRect().top
        const hauteur = window.innerHeight - top;

        this.styleHeight="height:"+hauteur+"px;overflow-y:scroll;overflow-x:clip;";
      }
    },

    mounted() {
      this.setComponentHeight();
    },

    i18n: FiltreLateralI18n,

};
